import styled from 'styled-components';
import { BORDER_RADIUS, CONTAINER_MAX_WIDTHS, FONT_COLOURS, GRADIENTS, isFocused, media } from '@belong/themes';
import { Button, StyledContainer as Container, Copy, RichText } from '@belong/ui-components';

export const HEIGHT = 72;
export const HEIGHT_WITH_UNIT = `${HEIGHT}px`;
export const ITEM_HEIGHT = '5.6rem';

export const Flex = styled.div`
  display: flex;
`;

export const FlexLogoSpacer = styled.div`
  // match exact size of belong logo
  width: 19.8rem;
  max-width: 19.8rem;
`;

export const FlexColumn = styled.div`
  width: 25%;
  max-width: 30rem;
  // padding must match HeaderBarLink
  padding: 0 1rem;
  ${media('xl')`
    padding: 0 2.4rem;
  `}
`;

export const ProfileMenuFlex = styled.div`
  display: flex;
  justify-content: end;

  nav {
    width: 100%;
  }
`;

export const MenuList = styled.ul`
  list-style: none;

  li {
    padding: 0.4rem 0;
  }
`;

export const ProfileMenuColumn = styled(FlexColumn)`
  display: flex;
  flex-direction: column;
  align-items: end;
  padding-right: 0;
`;

export const AccentStrip = styled.div`
  height: 0.8rem;
  background: ${GRADIENTS.ACCENT_STRIP_GLOBAL_HEADER};
`;

export const SummaryContainer = styled.div`
  border: none;
  outline: none;
  border-radius: ${BORDER_RADIUS.CARD};

  &:focus {
    ${isFocused(false, 1)};
  }
`;

export const FlexNavGroupWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
`;

export const Summary = styled(RichText).attrs({
  hasColor: FONT_COLOURS.LIGHT
})``;

export const SummaryCopy = styled(Copy).attrs({ isBold: true, variant: 'large' })`
  margin-top: 1.2rem;
`;

export const HelpText = styled(RichText).attrs({
  contentLength: 'short',
  hasColor: FONT_COLOURS.LIGHT,
  p: 'copySmall'
})``;

export const MiddleColumnWrapper = styled.div<{ rows: number }>`
  display: grid;
  grid-row-gap: 4rem;
  grid-auto-flow: column;
  grid-column-gap: 3.2rem;

  ${({ rows }): string => `grid-template-rows: repeat(${rows}, auto);`}
`;

export const LogoutButton = styled(Button)`
  margin-top: 1.6rem;
`;

export const StyledContainer = styled(Container)`
  margin: 0 2.3rem;

  // use XL max width for both LG & XL breakpoints
  max-width: ${CONTAINER_MAX_WIDTHS.xl};

  ${media('xl')`
    margin: 0 auto;
    padding-left: 3rem;
  `}
`;
